module.exports = __webpack_public_path__ + "img/logo-page-login.2e29a59c.webp";